export enum TenantsEvent {
    AddTenant = 'Tenants.ClickedAddNew',
    AddTenantUpgrade = 'Tenants.ClickedAddNewUpgrade',
    AddTenantContact = 'Tenants.ClickedAddNewContact',
}
